<div class="feature-flags">
  <div class="feature-flags__title">
      <p class="vox-heading-2" translate>internal-facilities.feature-flags.title</p>
  </div>
  <hr />
  <div *ngIf="!fetchFailed" class="feature-flags__content">
    <div class="feature-flags__content-actions">
      <button type="button" (click)="onAddFlag()" class="vox-btn vox-btn-secondary" translate>internal-facilities.feature-flags.buttons.create</button>
    </div>
    <div class="feature-flags__table">
      <gdp-feature-flags-table (onFlagDelete)="onFlagDelete()" (onFlagEdit)="flagEdited()" [flags]="flags" [loading]="loading"></gdp-feature-flags-table>
    </div>
  </div>
  <div *ngIf="fetchFailed" class="feature-flags__content">
    <div class="vox-inline-message vox-inline-message_light-grey">
      <div>
        <i class="icon-small-alert"></i>
        {{'internal-facilities.feature-flags.errors.fetch-failed' | translate}}
      </div>
      <button type="button" class="vox-btn vox-btn-secondary" (click)="fetchFlags()"
        translate>internal-facilities.feature-flags.buttons.retry</button>
    </div>
  </div>
</div>
